import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSpeaker24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconSpeaker24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.286 9.75h.584l.43-.396 3.2-2.939v11.17l-3.2-2.94-.43-.395H5a.5.5 0 0 1-.5-.5v-3.5a.5.5 0 0 1 .5-.5zM3 10.25a2 2 0 0 1 2-2h2.286l4.037-3.71c.642-.589 1.677-.134 1.677.737v13.446c0 .87-1.035 1.326-1.677.737l-4.037-3.71H5a2 2 0 0 1-2-2zm13.207-5.137a.75.75 0 0 1 .98-.406L16.9 5.4l.288-.693.003.002.005.002.014.006a3 3 0 0 1 .201.095c.13.064.31.16.522.29a8.3 8.3 0 0 1 1.55 1.233C20.62 7.485 21.75 9.315 21.75 12c0 2.678-1.1 4.507-2.21 5.658-.55.57-1.1.973-1.516 1.234a7 7 0 0 1-.708.388l-.014.006-.005.003h-.003l-.292-.684.291.685a.75.75 0 0 1-.589-1.38h.003l.021-.01.102-.05a5 5 0 0 0 .396-.227c.334-.21.784-.54 1.234-1.006.89-.924 1.79-2.395 1.79-4.617 0-2.216-.919-3.685-1.834-4.61a6.8 6.8 0 0 0-1.268-1.009 5 5 0 0 0-.512-.278l-.023-.01h-.001l-.002-.001a.75.75 0 0 1-.403-.98m-.854 3.507a.75.75 0 0 1 1.027-.267L16 9l.38-.646h.001l.002.001.003.002.008.005.024.014.073.048a4.8 4.8 0 0 1 .93.84c.504.593 1.029 1.509 1.029 2.736s-.525 2.143-1.029 2.736a4.8 4.8 0 0 1-.93.84l-.073.047-.024.015-.008.005-.003.002h-.002v.001L16 15l.38.646a.75.75 0 0 1-.764-1.29l.004-.003.035-.022q.05-.034.148-.109c.128-.1.302-.254.476-.458.346-.407.67-.991.67-1.764s-.324-1.357-.67-1.764a3.3 3.3 0 0 0-.624-.567l-.035-.022-.004-.003a.75.75 0 0 1-.262-1.024"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSpeaker24);
